export enum LatLonType {
    LAT = 'latitude',
    LON = 'longitude',
}
